import { Card, Collapse, Icon } from '@blueprintjs/core';
import ConditionalWrapper from 'Lib/hoc/ConditionalWrapper';
import withFocus from 'Lib/hoc/withFocus';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from './DetailTable.module.css';

const DetailPanel = ({
  title = '',
  hideTitleIfExpanded = false,
  titleButton,
  rightAlignTitleButton = true,
  children,
  footer,
  editable = false,
  disabled = false,
  collapsible = false,
  alternativeBackgroundColor = false,
  _hasFocus,
  onClick,
  onDoubleClick,
  marginBottom = 10,
  maxWidth,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleCollapseHandler = (e) => {
    setIsOpen(!isOpen);
    e.stopPropagation();
  };

  const cardClickHandler = (e) => {
    onClick && onClick(e);
    setIsOpen(true);
  };

  const cardDoubleClickHandler = (e) => {
    onDoubleClick && onDoubleClick(e);
    setIsOpen(true);
  };

  return (
    <Card
      elevation={!disabled && editable && _hasFocus ? 3 : 0}
      interactive={!disabled && editable}
      className={`${styles.collapsible_card} ${
        disabled
          ? styles.disabled
          : alternativeBackgroundColor
          ? styles.alt_background
          : ''
      }`}
      style={{
        height: isOpen ? '100%' : hideTitleIfExpanded ? 50 : 60,
        maxWidth: maxWidth || '100%',
      }}
      onClick={cardClickHandler}
      onDoubleClick={cardDoubleClickHandler}>
      {collapsible && (
        <Icon
          icon={isOpen ? 'minus' : 'plus'}
          onClick={toggleCollapseHandler}
          style={{
            position: 'absolute',
            top: hideTitleIfExpanded && !isOpen ? 16 : 10,
            right: 16,
            cursor: 'pointer',
            zIndex: 5,
          }}
        />
      )}
      <div className={styles.collapsible_wrapper}>
        {title && (!hideTitleIfExpanded || !isOpen) ? (
          <div
            className={
              hideTitleIfExpanded ? styles.left_title_div : styles.title_div
            }>
            {title}
            <ConditionalWrapper
              condition={rightAlignTitleButton}
              wrapper={(children) => (
                <div className={styles.title_div_button_box_right}>
                  {children}
                </div>
              )}>
              {titleButton}
            </ConditionalWrapper>
          </div>
        ) : (
          <div className={styles.title_div_no_text}>{titleButton}</div>
        )}
        <ConditionalWrapper
          condition={collapsible}
          wrapper={(children) => (
            <Collapse
              keepChildrenMounted
              className={styles.collapsible_body}
              isOpen={isOpen}>
              {children}
            </Collapse>
          )}>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              paddingBottom: marginBottom,
              overflowX: 'auto',
              overflowY: 'clip',
            }}>
            {children}
          </div>
          <div style={{ flexGrow: 1 }} />
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ marginTop: 'auto', width: '100%' }}>
            {footer}
          </div>
        </ConditionalWrapper>
      </div>
    </Card>
  );
};

DetailPanel.propTypes = {
  title: PropTypes.node,
  titleButton: PropTypes.node,
  hideTitleIfExpanded: PropTypes.bool,
  rightAlignTitleButton: PropTypes.bool,
  children: PropTypes.node,
  footer: PropTypes.node,
  maxWidth: PropTypes.number,
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
  collapsible: PropTypes.bool,
  alternativeBackgroundColor: PropTypes.bool,
  _hasFocus: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  marginBottom: PropTypes.number,
};

let DetailPanelWithFocus = withFocus(DetailPanel);

export default DetailPanelWithFocus;
